import { render, staticRenderFns } from "./ServiceProductForm.vue?vue&type=template&id=6339c747&"
import script from "./ServiceProductForm.vue?vue&type=script&lang=js&"
export * from "./ServiceProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports